import { t, useLanguage } from "@/i18n/LanguageContext";import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AiButton({ field, getText, onResult, onAuthError, testid }) {useLanguage();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!getText().trim()) {
      toast.error(t("Scrivi prima una bozza da migliorare"));
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/admin/ai-text", { text: getText(), field });
      if (data.text) {
        onResult(data.text);
        toast.success(t("Testo migliorato dall'AI (Claude)"));
      }
    } catch (e) {
      if (e.response?.status === 401) onAuthError();else
      toast.error(t(e.response?.data?.detail || "Generazione AI non riuscita"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" data-testid={testid} onClick={run} disabled={busy}
    className="inline-flex items-center gap-1 rounded-full border border-brand-navy/20 bg-brand-limelight px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-brand-navy transition-colors hover:bg-brand-lime disabled:opacity-60">
      <Sparkles className="h-3 w-3" /> {t(busy ? "AI al lavoro…" : "Migliora con AI")}
    </button>);

}
